__turbopack_context__.v({
  "featured_news_thumbnail_description": "NgWMRG_featured_news_thumbnail_description",
  "featured_news_thumbnail_description_source": "NgWMRG_featured_news_thumbnail_description_source",
  "featured_news_thumbnail_description_source_link": "NgWMRG_featured_news_thumbnail_description_source_link",
  "featured_news_thumbnail_description_story": "NgWMRG_featured_news_thumbnail_description_story",
  "featured_news_thumbnail_image": "NgWMRG_featured_news_thumbnail_image",
  "featured_news_thumbnail_wrapper": "NgWMRG_featured_news_thumbnail_wrapper",
});
